<template>
    <div class="page padding">
        <b-row>
            <b-col cols="12" xl="12">
                <b-card>
                    <div slot="header" v-html="caption"></div>
                    <b-table
                        hover
                        striped
                        responsive="sm"
                        :items="roles"
                        :fields="rolesTable.fields"
                        :current-page="rolesTable.currentPage"
                        :per-page="rolesTable.perPage"
                        @row-clicked="gotoRole"
                    >
                        <template slot="id" slot-scope="data">
                            <strong>{{data.item.id}}</strong>
                        </template>
                        <template slot="rol" slot-scope="data">
                            <strong>{{data.item.rol}}</strong>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col>
                            <nav>
                                <b-pagination
                                    size="sm"
                                    :total-rows="getRowCount(roles)"
                                    :per-page="rolesTable.perPage"
                                    v-model="rolesTable.currentPage"
                                    prev-text="Anterior"
                                    next-text="Siguiente"
                                    hide-goto-end-buttons
                                />
                            </nav>
                        </b-col>
                        <b-col align="right">
                            <b-button variant="primary" size="sm" to="/auth/roles/nuevo">
                                <i class="fa fa-plus"/>
                                Nuevo
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            caption: 'Listado de Roles',
            roles: [],
            rolesTable: {
                currentPage: 1,
                perPage: 5,
                fields: [
                    {
                        label: 'Nombre',
                        key: 'name'
                    },
                    {
                        label: 'Descripción',
                        key: 'description'
                    }
                ]
            }
        }
    },

    methods: {
        getRowCount(roles) {
            return roles.length
        },
        getRoles() {
            this.$api.get('roles').then(res => {
                this.roles = res.data;
            });
        },
        gotoRole(role) {
           this.$router.push(`/auth/roles/edit/${role.id}`)
        }
    },

    created: function() {
        this.getRoles();
    }
}
</script>

